import { Rating } from "@bit/primefaces.primereact.rating";
// import { Button } from "@material-ui/core";
import React from "react";
import PrimereactStyle from "@bit/primefaces.primereact.internal.stylelinks";
import {
  Col,
  Form,
  Label,
  Row,
  Input,
  FormGroup,
  Table,
  Button,
} from "reactstrap";
import globalStyles from "../../util/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLongArrowAltDown,
  faLongArrowAltUp,
} from "@fortawesome/free-solid-svg-icons";
import { dateObjectToInputString } from "../../util/view";
const styles = {
  ...globalStyles,
};

const SeshSummary = ({ formData, next, prev }) => {
  return (
    <>
      <Row noGutters className="mt-1">
        <Col xs="auto">
          <h2>Summary</h2>
        </Col>
      </Row>
      <Form>
        <Row form>
          <Col xs={6}>
            <FormGroup>
              <Label for="spotId">Spot</Label>
              <Input readOnly value={formData?.spot?.name} />
            </FormGroup>
          </Col>
          <Col xs="auto" sm={{ size: "auto", offset: 1 }}>
            <FormGroup>
              <Label for="rating">Rating</Label>
              <PrimereactStyle />
              <Rating
                readOnly
                className="star-rating-form"
                value={formData?.rating}
                cancel={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col xs={12} md={4}>
            <Label>Date</Label>
            <Input
              bsSize="sm"
              readOnly
              name="date"
              type="date"
              value={dateObjectToInputString(formData?.date)}
            />
          </Col>
          <Col xs={6} md={4}>
            <Label>Start Time</Label>
            <Input
              bsSize="sm"
              readOnly
              name="startTime"
              type="time"
              value={formData?.startTime}
            />
          </Col>
          <Col xs={6} md={4}>
            <Label>End Time</Label>
            <Input
              bsSize="sm"
              readOnly
              name="endTime"
              type="time"
              value={formData?.endTime}
            />
          </Col>
        </Row>
        <Row form>
          <Col xs={12}>
            <Label>Description</Label>
            <Input readOnly type="textarea" value={formData?.description} />
          </Col>
        </Row>
        <Row noGutters className="mt-1">
          <Col xs="auto">
            <h5>Swells</h5>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Table responsive borderless style={styles.table}>
              <thead className="bg-light" style={styles.tableBorder}>
                <tr>
                  <th>Height (ft)</th>
                  <th>Direction</th>
                  <th>Period (s)</th>
                </tr>
              </thead>
              <tbody className="bg-light" style={styles.tableBorder}>
                {formData?.swellsAttributes
                  ?.filter((swell) => !swell._destroy)
                  ?.map((swell, ndx) => (
                    <tr key={ndx}>
                      <td>
                        <Input readOnly value={swell.height} />
                      </td>
                      <td>
                        <Input readOnly value={swell.direction} />
                      </td>
                      <td>
                        <Input readOnly value={swell.period} />
                      </td>
                    </tr>
                  ))}
                {formData?.swellsAttributes?.length === 0 && (
                  <tr>
                    <td className="text-center" colSpan="3">
                      No Swells Added
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row noGutters style={styles.section}>
          <Col xs="auto">
            <h5>Tides</h5>
          </Col>
        </Row>
        <Row form className="mt-1">
          <Col xs={5}>
            <Label>Start Tide</Label>
            <Input
              step={0.1}
              readOnly
              value={
                formData?.tidesAttributes?.filter((tide) => !tide._destroy)[0]
                  ?.height
              }
              type="number"
            />
          </Col>
          <Col xs={1} style={{ paddingLeft: 0 }}>
            <Button color="primary" outline disabled style={{ marginTop: 32 }}>
              <FontAwesomeIcon
                icon={
                  formData?.tidesAttributes?.filter((tide) => !tide._destroy)[0]
                    ?.rising
                    ? faLongArrowAltUp
                    : faLongArrowAltDown
                }
              />
            </Button>
          </Col>
          <Col xs={5}>
            <Label>End Tide</Label>
            <Input
              step={0.1}
              readOnly
              value={
                formData?.tidesAttributes?.filter((tide) => !tide._destroy)[1]
                  ?.height
              }
              type="number"
            />
          </Col>
          <Col xs={1} style={{ paddingLeft: 0 }}>
            <Button color="primary" outline disabled style={{ marginTop: 32 }}>
              <FontAwesomeIcon
                icon={
                  formData?.tidesAttributes?.filter((tide) => !tide._destroy)[0]
                    ?.rising
                    ? faLongArrowAltUp
                    : faLongArrowAltDown
                }
              />
            </Button>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs="auto">
            <Button onClick={prev}>Previous</Button>
          </Col>
          <Col xs="auto" className="ml-auto">
            <Button color="primary" onClick={() => next(formData)}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default SeshSummary;
